import React from 'react';
import ConfirmModal from '../../../../Common/ConfirmModal';
import useTranslation from '../../../../../util/hooks/useTranslation';

const LogoutModal = ({ initModal, toggleModal, handleLogout }) => {
    const t = useTranslation('ConfirmModal');

    return (
        <ConfirmModal
            header={{ title: t('Logout') }}
            confirmText={t('Do you want to log out?')}
            initModal={initModal}
            toggleModal={toggleModal}
            okCallback={handleLogout}
        />
    );
};

export default LogoutModal;
